/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M24 12c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0s12 5.3726 12 12Zm-1.6361 1.6953C21.5534 18.6882 17.2218 22.5 12 22.5c-2.5079 0-4.8104-.8792-6.6161-2.3462l6.9128-7.3737 10.0672.9152Zm.1342-1.494-9.7481-.8862V1.5264C18.1989 1.9109 22.5 6.4532 22.5 12c0 .0672-.0006.1343-.0019.2013ZM11.25 1.5263C5.801 1.911 1.5 6.4533 1.5 12c0 2.7513 1.0582 5.2554 2.7898 7.1276l6.9602-7.4242V1.5264Z"
    clipRule="evenodd"
  />,
  'Chart'
);
